<template>
  <div class="user-status-filter-item organization">
    <label
      class="item-label"
      v-t.preserve="'appUserStatusFilterOrganization.organization'"
    />
    <organization-group-selector
      ref="selector"
      size="sm"
      v-bind:domain-name="$t('appUserStatusFilterOrganization.organization')"
      v-bind:value="value"
      v-on:selected="$_onChange"
    />
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'AppUserStatusFilterOrganization',
  props: {
    /**
     * 選択値
     */
    organizationIds: {
      type: Array,
      default: null,
    },
  },
  data: function () {
    return {
      // ローカル値
      value: null,
      // 表示テキスト
      text: '',
    }
  },
  computed: {
    /**
     * イベント返却値
     * @type {Object}
     */
    result: function () {
      return {
        value: { organizationIds: this.value },
        text: this.value == null ? '' : this.text,
      }
    },
  },
  watch: {
    organizationIds: function () {
      this.$_applyToValue()
    },
  },
  mounted: async function () {
    await this.$nextTick() // organizationGroupSelector の mount 待ち
    this.$_applyToValue()
  },
  methods: {
    /**
     * props を value に反映する
     */
    $_applyToValue: function () {
      const isSame = _.isEqual(this.value, this.organizationIds)
      if (isSame) return

      // 外部からの値変更時はテキストを反映する必要があるので
      // 1回だけ change イベントを listen してテキスト取得後にイベントを発行する
      this.$refs['selector'].$once('change', this.$_onChange)

      this.value = this.organizationIds ? [...this.organizationIds] : null
    },

    /**
     * 変更時処理
     */
    $_onChange: function (value, text) {
      this.value = value
      this.text = text
      /**
       * 選択値変更イベント
       * @param {Object} value 選択値
       * @param {String} text 選択値表示テキスト
       */
      this.$emit('changed', this.result)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/user/user-status-filter-item';
</style>
